import { MessageCircle, Smartphone, Sun, TrendingDown } from "lucide-react";
import { Overline, SectionTitle, Accent, Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01", icon: MessageCircle, title: "Você me manda a sua conta de luz",
    text: "Pelo WhatsApp ou pelo formulário. Eu confiro se a sua distribuidora é atendida e qual é o desconto da sua região.",
  },
  {
    n: "02", icon: Smartphone, title: "Você assina tudo pelo celular",
    text: "Cadastro 100% digital, sem obra, sem trocar medidor e sem investimento. Nada muda no seu imóvel.",
  },
  {
    n: "03", icon: Sun, title: "A usina solar injeta energia na rede",
    text: "A energia gerada em usinas parceiras vira créditos que a distribuidora abate da sua conta. O primeiro desconto costuma aparecer em cerca de 90 dias; o prazo exato vem no contrato.",
  },
  {
    n: "04", icon: TrendingDown, title: "Você paga menos todo mês",
    text: "Você passa a receber duas faturas: a da distribuidora, bem menor, e a da iGreen com desconto. Somadas, saem mais baratas que a conta de antes.",
  },
];

export const HowItWorks = () => (
  <section id="como-funciona" className="relative py-24 sm:py-32 bg-[#04120E]" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <Overline>Como funciona</Overline>
        <SectionTitle className="max-w-3xl">
          Do seu WhatsApp até a <Accent>conta mais barata</Accent>, em 4 passos.
        </SectionTitle>
        <p className="mt-4 max-w-2xl text-sm sm:text-base text-emerald-100/55 leading-relaxed">
          Nada muda no seu imóvel nem na sua distribuidora. A energia vem de usinas solares parceiras e entra como crédito na sua conta.
        </p>
      </Reveal>
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div
              data-testid={`step-card-${s.n}`}
              className="group relative h-full rounded-2xl border border-white/10 bg-[#0B261E]/60 p-7 overflow-hidden transition-[border-color,transform] duration-300 hover:border-[#00E676]/45 hover:-translate-y-1.5"
            >
              <span className="absolute -top-5 -right-3 font-heading text-[7rem] font-extrabold text-[#00E676]/[0.07] leading-none select-none transition-colors duration-500 group-hover:text-[#00E676]/[0.14]">
                {s.n}
              </span>
              <span className="relative grid place-items-center w-12 h-12 rounded-xl bg-[#00E676]/12 border border-[#00E676]/25 text-[#00E676] mb-6">
                <s.icon size={22} />
              </span>
              <h3 className="relative font-heading text-lg font-bold text-white leading-snug">{s.title}</h3>
              <p className="relative mt-3 text-sm text-emerald-100/55 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
